import { ReactNode } from 'react';

export enum SettingsCategory {
  CloudHub = 'CloudHub',
  CloudHub2 = 'CloudHub 2.0',
  RTF = 'Runtime Fabric',
  Hybrid = 'Hybrid'
}

export enum SettingsCategoryUrl {
  Cloudhub = 'cloudhub',
  Cloudhub2 = 'cloudhub2',
  RTF = 'runtime-fabric',
  Hybrid = 'hybrid'
}

export type EnrichedSettingsCategory = {
  url: string
  category: SettingsCategory
  content: ReactNode
  hideForPCE?: boolean
  hideForGovCloud?: boolean
}

export enum CloudHubStatus {
  undeployed = 'UNDEPLOYED',
  deploying = 'DEPLOYING',
  undeploying = 'UNDEPLOYING',
  started = 'STARTED'
}

export const isCloudHubCategory = (cat: string) => {
  return cat === SettingsCategory.CloudHub || cat === SettingsCategoryUrl.Cloudhub
}

export const isCloudHub2Category = (cat: string) => {
  return cat === SettingsCategory.CloudHub2 || cat === SettingsCategoryUrl.Cloudhub2
}

export const isRTFCategory = (cat: string) => {
  return cat === SettingsCategory.RTF || cat === SettingsCategoryUrl.RTF
}

export const isHybridCategory = (cat: string) => {
  return cat === SettingsCategory.Hybrid || cat === SettingsCategoryUrl.Hybrid
}

export const getSettingsCategory = (cat: string) => {
  if (isCloudHub2Category(cat)) return SettingsCategory.CloudHub2
  if (isRTFCategory(cat)) return SettingsCategory.RTF
  if (isHybridCategory(cat)) return SettingsCategory.Hybrid
  return  SettingsCategory.CloudHub
}
